<template>
  <div id="app">
    <div class="container">
      <vue-signature-pad
          id="signature"
          :width="width"
          :height="height"
          ref="signaturePad"
          :options="options"
      />
      <div class="buttons">
        <p class="styled-button" @click="undo">Undo</p>
        <p class="styled-button" @click="clear">Clear</p>
        <p class="styled-button" @click="save">Save</p>
      </div>
    </div>
  </div>
</template>

<script>
import { VueSignaturePad } from 'vue-signature-pad';

export default {
  name: "VueSignature",
  components: {
    VueSignaturePad
  },
  props: {
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '200px'
    },
    initialColor: {
      type: String,
      default: "black"
    }
  },
  data() {
    return {
      options: {
        penColor: this.initialColor
      }
    };
  },
  methods: {
    getSignature() {
      // Retrieve the signature data
      return this.signatureData; // Replace with actual method to get signature
    },
    undo() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.undoSignature();
      }
    },
    clear() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature();
      }
    },
    save() {
      try {
        if (this.$refs.signaturePad) {
          const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
          if (!isEmpty) {
            // console.log(data);
            alert("Signature saved successfully.");
            this.$emit('signature-saved', data); // Emitting the data
          } else {
            alert('Please provide a signature before saving.');
          }
        } else {
          console.error('Signature pad reference is not available.');
          alert('Unable to access the signature pad.');
        }
      } catch (error) {
        console.error('Error saving signature:', error);
        alert('An error occurred while saving the signature.');
      }
    }
  }
};
</script>

<style scoped>
/* Ensure the signature pad container is responsive */
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
  width: 100%; /* Ensure the signature pad takes full width */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
}

/* Container styling for responsiveness */
.container {
  width: 100%;
  padding: 8px 16px;
  box-sizing: border-box; /* Ensure padding is included in width */
}

/* Flexbox setup for buttons */
.buttons {
  display: flex;
  flex-wrap: wrap; /* Allow buttons to wrap to the next line if needed */
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}

/* Button styling */
.styled-button {
  border: none;
  margin-bottom: 10px; /* Adjust margin for smaller screens */
  font-size: 14px; /* Slightly smaller font size */
  font-family: Poppins-Medium;
  color: black;
  line-height: 1.2;
  text-transform: uppercase;

  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 80px; /* Reduce minimum width for smaller screens */
  height: 40px;
  border-radius: 25px;

  background: #e6e6e6;
  background: linear-gradient(bottom, #57b846, #d4d4d4);

  position: relative;
  z-index: 1;
  transition: all 0.4s;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .styled-button {
    font-size: 13px; /* Smaller font size for tablets */
    min-width: 70px; /* Reduce minimum width for tablets */
  }
}

@media (max-width: 480px) {
  .styled-button {
    font-size: 12px; /* Smaller font size for mobile phones */
    min-width: 60px; /* Further reduce minimum width for mobile phones */
  }
}

</style>
